"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _Text = _interopRequireDefault(require("../Text"));
var _Button = _interopRequireDefault(require("../Button"));
var _IconUser = _interopRequireDefault(require("../../icons/General/IconUser"));
var _react2 = require("@emotion/react");
var _IconUserThin = _interopRequireDefault(require("../../icons/General/IconUserThin"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const UserMenu = ({
  name,
  firstname,
  email,
  type = 'default',
  iconType = 'default',
  avatarUrl,
  hideAvatarOnButton,
  iconSize,
  logout,
  children
}) => {
  const [open, setOpen] = (0, _react.useState)(false);
  const contextMenuRef = /*#__PURE__*/(0, _react.createRef)();
  const optionsRef = /*#__PURE__*/(0, _react.createRef)();
  const {
    secondary
  } = (0, _react2.useTheme)();
  const isMySite = type === 'mysite';
  (0, _react.useEffect)(() => {
    const handleClickOutside = e => {
      const node = contextMenuRef.current;
      if (node && node.contains(e.target)) {
        return;
      }
      setTimeout(() => {
        setOpen(false);
      }, 50);
    };
    const handleOptionsClick = e => {
      const node = optionsRef.current;
      if (node && node.contains(e.target)) {
        setTimeout(() => {
          setOpen(false);
        }, 100);
      }
    };
    if (open) {
      document.addEventListener('mouseup', handleClickOutside);
      document.addEventListener('mouseup', handleOptionsClick);
    } else {
      document.removeEventListener('mouseup', handleClickOutside);
      document.removeEventListener('mouseup', handleOptionsClick);
    }
    return () => {
      document.removeEventListener('mouseup', handleClickOutside);
      document.removeEventListener('mouseup', handleOptionsClick);
    };
  }, [open, contextMenuRef, optionsRef]);
  const UserIcon = iconType === 'thin' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconUserThin.default, {
    size: iconSize,
    color: isMySite ? secondary : 'black'
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconUser.default, {
    size: iconSize,
    color: isMySite ? secondary : 'black'
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.UserWrapper, {
    hasFirstName: Boolean(firstname),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
      nostyle: true,
      afterIcon: avatarUrl && !hideAvatarOnButton ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ImageSmallWrapper, {
        size: iconSize,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: avatarUrl,
          alt: "Profil bilde"
        })
      }) : UserIcon,
      onClick: () => setOpen(!open),
      trackingEvent: "Usermenu toggle",
      trackingName: "Topbar",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        small: true,
        semibold: true,
        children: firstname || ''
      })
    }), open && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.UserMenuContent, {
      ref: contextMenuRef,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.UserMenuInformation, {
        children: [avatarUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ImageWrapper, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: avatarUrl,
            alt: "Profil bilde"
          })
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconUser.default, {
          size: "30px",
          color: secondary
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          semibold: true,
          children: name
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          wordBreak: "break-word",
          subtle: true,
          small: true,
          children: email
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ref: optionsRef,
        children: children
      }), logout && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LogoutWrapper, {
        children: logout
      })]
    })]
  });
};
var _default = exports.default = UserMenu;